import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function changePassword (password, token) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getLogin)
      }, 500)
    })
  } else {
    const req = {
      url: '/api/login/changePassword',
      method: 'POST',
      data: {
        password: password,
        Token: token
      }
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { changePassword }
